<div class="header fs-24 fw-7 text-primary">Candidature(s) en cours</div>
<div class="m-5">
  <div class="d-flex align-items-start gap-4 w-100 mb-px-24" [formGroup]="formFilter">
    <!-- <app-custom-input inputClass="flex-grow-1"  placeholder="Rechercher une mission" [showLabel]='false' [required]="false" [sideIcon]='"/assets/icons/search-grey.svg"'  ></app-custom-input> -->
    <div class="me-4 inner-add-on left-add-on" >
      <input
        type="search"
        class="input-form-control"
        placeholder="Recherche par référence"
        formControlName="missionTitle"
      />
      <svg-icon
        class="inner-icon left"
        svgClass="placeholder-icon"
        src="/assets/icons/search-grey.svg"
      ></svg-icon>
    </div>
    <div class="d-flex" style="margin-bottom: -21px">
      <mat-form-field
        appearance="outline"
        class="w-100 d-flex align-items-center "
      >
        <mat-label class="fs-16 fw-6"
          ><svg-icon src="/assets/icons/filter.svg"></svg-icon> Toutes les
          missions</mat-label
        >
        <mat-select multiple>
          @for (item of missionsList; track item) {
          <mat-option [value]="item?.id">
            {{ item?.missionTitle }}
          </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <app-data-table
    [dataSource]="candidatureList"
    [columns]="customColumns"
    (onFullRowClick)="handleFullRowClick($event)"

    [pageSize]="size"
    [totalItems]="candidatureList.length"
    [showActions]="true"
    [showSideBar]="true"
    [isLoading]="loading"
    (nextPage)="pagination($event)"
  ></app-data-table>
</div>
